import $ from 'jquery';

var pageScrollTop;
var myTimeout;

$('.nav-toggle').on('click', function () {
    var toggleActiveClass = 'nav-toggle--active';
    var navActiveClass = 'navigation--visible';
    var $page = $('.page');
    clearTimeout(myTimeout);

    if ($(this).hasClass(toggleActiveClass)) {
        $(this).removeClass(toggleActiveClass);
        $('.navigation').removeClass(navActiveClass);
        $page.removeClass('page--blocked');
        $(window).scrollTop(pageScrollTop);

        $('.navigation__page').removeClass('navigation__page--active');
    } else {
        pageScrollTop = $(window).scrollTop();
        $(this).addClass(toggleActiveClass);
        $('.navigation').addClass(navActiveClass);
        //$page.addClass('page--blocked');
        $page.scrollTop(pageScrollTop);
        myTimeout = setTimeout(function () {
            $('.navigation').addClass('navigation--opened')
        }, 500);
    }
});
